import { render, staticRenderFns } from "./UserDeactivatedUsers.vue?vue&type=template&id=469b1bb9&scoped=true"
import script from "./UserDeactivatedUsers.vue?vue&type=script&lang=js"
export * from "./UserDeactivatedUsers.vue?vue&type=script&lang=js"
import style0 from "./UserDeactivatedUsers.vue?vue&type=style&index=0&id=469b1bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469b1bb9",
  null
  
)

export default component.exports